import { Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { Tag, TagsList } from '../../../../Tag'
import { Rule, RuleContent, RuleDescription } from '../../../RuleStack'
import { messages } from '../messages'

export function ShippingCountriesRule(props: { shippingCountries: string[] }) {
  const { $t } = useIntl()
  const { shippingCountries } = props

  if (!shippingCountries.length) return

  return (
    <Rule>
      <RuleDescription>
        {$t(messages.view.shippingCountries, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
          count: shippingCountries.length,
        })}
      </RuleDescription>

      <RuleContent>
        <TagsList>
          {shippingCountries.map((countryCode, index) => (
            <Tag key={index}>{countryCode}</Tag>
          ))}
        </TagsList>
      </RuleContent>
    </Rule>
  )
}
